const categories = document.querySelector('.categories')

if (categories) {
    window.addEventListener('scroll', () => {
        let offset = categories.getBoundingClientRect().y;

        if (offset === 0) {
            categories.classList.add('is-sticky')
        } else if (offset > 100) {
            // By only removing this once you've scrolled a  little bit past it on your
            // way up you avoid the issue where when the title "shrinks" when it is sticky,
            // it's "offset" is shifted by a few pixels.
            categories.classList.remove('is-sticky');
        }
    });
}
